import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import enFlag from './flags/us.jpg';
import germanyFlag from './flags/germany.jpg';
import italyFlag from './flags/italy.jpg';
import spainFlag from './flags/spain.jpg';
import russiaFlag from './flags/russia.jpg';
const Languages = [{
  name: 'English',
  flag: enFlag
}, {
  name: 'German',
  flag: germanyFlag
}, {
  name: 'Italian',
  flag: italyFlag
}, {
  name: 'Spanish',
  flag: spainFlag
}, {
  name: 'Russian',
  flag: russiaFlag
}];

class LanguageDropdown extends Component {
  constructor(props) {
    super(props);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.state = {
      dropdownOpen: false
    };
  }
  /*:: toggleDropdown: () => void */


  toggleDropdown() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  render() {
    const enLang = Languages[0] || {};
    return /*#__PURE__*/React.createElement(Dropdown, {
      isOpen: this.state.dropdownOpen,
      toggle: this.toggleDropdown
    }, /*#__PURE__*/React.createElement(DropdownToggle, {
      "data-toggle": "dropdown",
      tag: "button",
      className: "nav-link dropdown-toggle arrow-none btn btn-link",
      onClick: this.toggleDropdown,
      "aria-expanded": this.state.dropdownOpen
    }, /*#__PURE__*/React.createElement("img", {
      src: enLang.flag,
      alt: enLang.name,
      className: "mr-1",
      height: "12"
    }), ' ', /*#__PURE__*/React.createElement("span", {
      className: "align-middle"
    }, enLang.name), /*#__PURE__*/React.createElement("i", {
      className: "mdi mdi-chevron-down align-middle"
    })), /*#__PURE__*/React.createElement(DropdownMenu, {
      right: true,
      className: "dropdown-menu-animated topbar-dropdown-menu"
    }, /*#__PURE__*/React.createElement("div", {
      onClick: this.toggleDropdown
    }, Languages.map((lang, i) => {
      return /*#__PURE__*/React.createElement(Link, {
        to: "/",
        className: "dropdown-item notify-item",
        key: i + '-lang'
      }, /*#__PURE__*/React.createElement("img", {
        src: lang.flag,
        alt: lang.name,
        className: "mr-1",
        height: "12"
      }), ' ', /*#__PURE__*/React.createElement("span", {
        className: "align-middle"
      }, lang.name));
    }))));
  }

}

export default LanguageDropdown;